interface IProps {
	children: React.ReactNode;
	borderCustom?: boolean;
}

export const FootballField = ({ children, borderCustom }: IProps) => {
	const borderColor = borderCustom ? 'border-[#aeaeae]' : 'border-[#707070]';
	return (
		<div
			className={`relative w-full border-2 ${borderColor} rounded-lg bg-soccerfield bg-contain py-4 h-[392px]`}
		>
			<div className="absolute inset-0 pointer-events-none">
				<div className="flex h-full flex-col items-center gap-3">
					<div className="flex w-full flex-col items-start justify-center">
						<div
							className={`w-full bg-black/5 h-14 border-b-2 relative flex justify-center -top-0.5 ${borderColor}`}
						>
							<div
								className={`w-14 h-7 border-r-2 border-l-2 absolute ${borderColor}`}
							/>
						</div>
					</div>

					<div className="w-full flex flex-col justify-between">
						{[10, 20, 30, 40, 50, 40, 30, 20, 10].map(
							(item, index) => (
								<div
									key={index}
									className="w-full relative flex flex-col items-center justify-between "
								>
									<div
										className={
											`w-full h-3.5 border-b ` +
											(index === 0 ? ' border-t' : '') +
											(item === 50
												? borderCustom
													? ' border-custom-gray-11'
													: ' border-white'
												: ` ${borderColor}`)
										}
									/>
									<div
										className={
											'absolute rotate-90 left-5 font-bahnschrift ' +
											(item === 50
												? ' tracking-[3px] top-[3px] left-[17px]'
												: '') +
											(item === 10
												? ' left-[22px]'
												: '') +
											(borderCustom
												? ' text-custom-gray-11'
												: ' text-white')
										}
									>
										{item}
									</div>
									<div
										className={`w-full h-3.5 border-b ${borderColor}`}
									/>
								</div>
							)
						)}
					</div>

					<div className="flex w-full flex-col items-start justify-center">
						<div
							className={`w-full bg-black/5 h-14 border-t-2 relative flex justify-center -bottom-0.5 ${borderColor}`}
						>
							<div
								className={`w-14 h-7 border-r-2 border-l-2 absolute bottom-0.5 ${borderColor}`}
							/>
						</div>
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};
